<template>
  <div class="form-block">
    <div class="header-block">
      <div class="title">
        Create Pet Owner Profile
      </div>
      <div class="lead">
        Map<br/>
        (2/4)
      </div>
    </div>
    <div>
      <div class="custom-row">
        <span class="form-label">Google Map</span>
        <el-input
          v-model="findAddress"
          @keyup.enter.native="OnFindAddressChange"
          placeholder="กรอกสถานที่"
          style="width: 100%"
        ></el-input>
        <span class="error">{{ errors.first('username') }}</span>
      </div>

      <div class="custom-row">
        <LocationPicker v-if="loaded"
          v-on:locationChange="locationChange"
          :apiKey="googleApiKey"
          :initialLat="location.lat"
          :initialLng="location.lng"
          ref="map"
        />
      </div>

      <div class="custom-row">
        <el-button
          :loading="submitButtonLoading"
          type="button"
          class="btn btn-primary form-submit-btn location-save-btn"
          @click="saveLocation">save this location</el-button>
      </div>

      <div class="custom-row text-center">
        <router-link
          :to="{ name: 'petOwnerGeneralInfo' }"
          class="btn btn-plain form-submit-btn">
          &lt; Back
        </router-link>
        <router-link
          :to="{ name: 'petOwnerAddress' }"
          class="btn btn-primary form-submit-btn">
          Next &gt;
        </router-link>
        <span v-for="(error, key) of errMessage"
          v-bind:key="key"
          class="error">{{ key }}: {{ error }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import LocationPicker from '@/components/LocationPicker'
import { googleApiKey } from '@/constants'

export default {
  data() {
    return {
      findAddress: "",
      firstname: '',
      submitButtonLoading: false,
      errMessage: [],
      location: {},
      loaded: false,
      googleApiKey: googleApiKey
    }
  },
  async mounted() {
    await this.$store.dispatch('ui/setIsFullScreenLoading', true)
    await this.$store.dispatch('owner/getOwnerProfile')
    this.firstname = this.$store.state.owner.profile.profile.firstname
    if (this.$store.state.owner.profile.profile.addresses.length) {
      var address = this.$store.state.owner.profile.profile.addresses[0]
      this.location = {
        lat: address.latitude || 0,
        lng: address.longitude || 0
      }
    } else {
      this.location = {
        lat: 0,
        lng: 0,
      }
    }
    this.loaded = true
    await this.$store.dispatch('ui/setIsFullScreenLoading', false)
  },
  methods: {
    locationChange(location) {
      this.location = location
    },
    async saveLocation() {
      this.submitButtonLoading = true
      try {
        await this.$store.dispatch('owner/updateProfile', {
          data: {
            profile: {
              firstname: this.firstname,
              addresses: [
                {
                  latitude: this.location.lat.toFixed(12),
                  longitude: this.location.lng.toFixed(12)
                }
              ]
            }
          }
        })
        this.$message('Your location was saved')
      } catch (err) {
        this.errMessage = err
      }
      this.submitButtonLoading = false
    },
    OnFindAddressChange () {
      this.$refs.map.findLocation(this.findAddress);
    },
  },
  components: {
    LocationPicker
  }
}
</script>

<style lang="scss" scoped>
.form-block {
  @extend %block-container;
  @extend %form-style;
  .location-save-btn {
    display: block;
    width: 100%;
    background-color: #536c8d;
    margin: 0;
  }
}
.custom-row {
  margin-bottom: 15px;
}
</style>
